import { mapGetters, mapMutations } from 'vuex'
import LayoutDefault from '@/components/layout/default/LayoutDefault.vue'
import LayoutInsights from '@/components/layout/insights/LayoutInsights.vue'

const mixin = {
  components: {
    LayoutDefault,
    LayoutInsights
  },

  computed: {
    ...mapGetters('base', ['viewLayout'])
  },

  methods: {
    ...mapMutations('base', {
      setIsLoading: 'SET_IS_LOADING'
    }),

    updatePageTitle () {
      // @ts-ignore
      if (this.viewLayout === 'LayoutInsights') {
        const title = document.title.replace('WeClever', 'Clever Insights')

        document.title = title
      }
    }
  },

  created () {
    // @ts-ignore
    this.setIsLoading(false)

    // @ts-ignore
    this.updatePageTitle ()
  }
}

export default mixin
